import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {OperatoryDataModel} from '../../../models/clients/operatory-data.model';
import {WorkstationConfigurationModel} from '../../../models/configuration/workstation-configuration.model';
import {WorkstationsComponent} from '../workstations/workstations.component';

@Injectable({
  providedIn: 'root'
})
export class OperatoriesService {
  constructor(private http: HttpClient) { }

  getClients(): Observable<any[]> {
    let url: string;
    let method: string = 'operatory-configuration/tdo-clients';
    url = environment.TDOurl + method;
    return this.http.get<any>(url);
  }

  getClientLocations(tdocid: string ): Observable<any[]> {
    let url: string;
    let method: string = 'operatory-configuration/tdo-clients-locations/' + tdocid;
    url = environment.TDOurl + method;
    return this.http.get<any>(url);
  }

  getLocationOperatories(locid: string): Observable<OperatoryDataModel[]> {
    let url: string;
    let method: string = 'operatory-configuration/tdo-operatories/' + locid;
    url = environment.TDOurl + method;
    return this.http.get<OperatoryDataModel[]>(url);
  }

  saveOperatories(operatories: any): Observable<OperatoryDataModel[]> {
    return this.http.post<OperatoryDataModel[]>(`${environment.TDOurl}operatory-configuration/save-operatories`, operatories);
  }

  deleteOperatory(model: OperatoryDataModel) {
    return this.http.get(`${environment.TDOurl}operatory-configuration/delete-operatory/${model.OperatoryId}`);
  }

  getWorkstations(locId: string, operatoryId: string): Observable<WorkstationConfigurationModel[]> {
    return this.http.get<WorkstationConfigurationModel[]>(`api/operatory-configuration/get-workstations/${locId}/${operatoryId}`);
  }

  deleteWorkstation(workstationId: string): Observable<void> {
    return this.http.get<void>(`api/operatory-configuration/delete-workstation/${workstationId}`);
  }

  saveWorkstations(workstations: WorkstationConfigurationModel[]): Observable<WorkstationConfigurationModel[]> {
    return this.http.post<WorkstationConfigurationModel[]>('api/operatory-configuration/save-workstations', workstations);
  }
}
